import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Question" }, [
      _createElementVNode("path", {
        id: "Vector (Stroke)",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.00016 1.66659C4.05464 1.66659 1.66683 4.0544 1.66683 6.99992C1.66683 9.94544 4.05464 12.3333 7.00016 12.3333C9.94568 12.3333 12.3335 9.94544 12.3335 6.99992C12.3335 4.0544 9.94568 1.66659 7.00016 1.66659ZM0.333496 6.99992C0.333496 3.31802 3.31826 0.333252 7.00016 0.333252C10.6821 0.333252 13.6668 3.31802 13.6668 6.99992C13.6668 10.6818 10.6821 13.6666 7.00016 13.6666C3.31826 13.6666 0.333496 10.6818 0.333496 6.99992Z",
        fill: "#6E0AFA"
      }),
      _createElementVNode("path", {
        id: "Vector",
        d: "M7 11C7.41421 11 7.75 10.6642 7.75 10.25C7.75 9.83579 7.41421 9.5 7 9.5C6.58579 9.5 6.25 9.83579 6.25 10.25C6.25 10.6642 6.58579 11 7 11Z",
        fill: "#6E0AFA"
      }),
      _createElementVNode("path", {
        id: "Vector (Stroke)_2",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.97967 3.536C6.46694 3.33416 7.00312 3.28135 7.5204 3.38425C8.03769 3.48714 8.51284 3.74112 8.88578 4.11406C9.25872 4.487 9.5127 4.96215 9.61559 5.47943C9.71848 5.99672 9.66568 6.5329 9.46384 7.02017C9.26201 7.50744 8.92021 7.92391 8.48168 8.21693C8.22967 8.38532 7.9522 8.50859 7.66167 8.58299C7.62067 8.91186 7.34014 9.16634 7.00016 9.16634C6.63197 9.16634 6.3335 8.86787 6.3335 8.49968V7.99968C6.3335 7.63149 6.63197 7.33301 7.00016 7.33301C7.26387 7.33301 7.52166 7.25481 7.74092 7.1083C7.96019 6.96179 8.13109 6.75355 8.232 6.50992C8.33292 6.26629 8.35932 5.9982 8.30788 5.73956C8.25643 5.48091 8.12944 5.24334 7.94297 5.05687C7.7565 4.8704 7.51892 4.74341 7.26028 4.69196C7.00164 4.64051 6.73355 4.66692 6.48992 4.76784C6.24628 4.86875 6.03805 5.03965 5.89154 5.25892C5.74503 5.47818 5.66683 5.73597 5.66683 5.99968C5.66683 6.36787 5.36835 6.66634 5.00016 6.66634C4.63197 6.66634 4.3335 6.36787 4.3335 5.99968C4.3335 5.47226 4.48989 4.95669 4.78291 4.51816C5.07593 4.07962 5.4924 3.73783 5.97967 3.536Z",
        fill: "#6E0AFA"
      })
    ], -1)
  ])))
}
export default { render: render }